// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>18</span>&nbsp;&nbsp;All this has come upon us,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;though we have not forgotten you&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and have not played false to your covenant.<br> </p> </div></div>";
// Exports
module.exports = code;